import {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
} from 'react';

const noop: () => void = () => null;

const DesktopMenuContext = createContext({
  isExpandedMenu: true,
  isShowMenu: true,
  showMenu: noop,
  hideMenu: noop,
  expandMenu: noop,
  collapseMenu: noop,
  toggleMenuExpanded: noop,
});

export function useDesktopMenuContext() {
  return useContext(DesktopMenuContext);
}

function DesktopMenuProvider({ children }) {
  const [isShowMenu, setIsShowMenu] = useState(true);
  const [isExpandedMenu, setIsExpandedMenu] = useState(true);

  const showMenu = useCallback(() => {
    setIsShowMenu(true);
  }, []);

  const hideMenu = useCallback(() => {
    setIsShowMenu(false);
  }, []);

  const expandMenu = useCallback(() => {
    setIsExpandedMenu(true);
  }, []);

  const collapseMenu = useCallback(() => {
    setIsExpandedMenu(false);
  }, []);

  const toggleMenuExpanded = useCallback(() => {
    setIsExpandedMenu((prev) => !prev);
  }, []);

  const value = useMemo(
    () => ({
      isShowMenu,
      isExpandedMenu,
      showMenu,
      hideMenu,
      expandMenu,
      collapseMenu,
      toggleMenuExpanded,
    }),
    [
      isShowMenu,
      showMenu,
      hideMenu,
      isExpandedMenu,
      expandMenu,
      collapseMenu,
      toggleMenuExpanded,
    ],
  );

  return (
    <DesktopMenuContext.Provider value={value}>
      {children}
    </DesktopMenuContext.Provider>
  );
}

export { DesktopMenuProvider };
